import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "edit-company" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "no-contacts"
}
const _hoisted_4 = { class: "bottom" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_CompanyTile = _resolveComponent("CompanyTile")
  const _component_TrackerButtongroup = _resolveComponent("TrackerButtongroup")
  const _component_TrackerSegment = _resolveComponent("TrackerSegment")
  const _component_TrackerSlider = _resolveComponent("TrackerSlider")
  const _component_TrackerTextarea = _resolveComponent("TrackerTextarea")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_PulseButton = _resolveComponent("PulseButton")
  const _component_TrackerContacts = _resolveComponent("TrackerContacts")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_TrackerDelete = _resolveComponent("TrackerDelete")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($props.head)
            ? (_openBlock(), _createBlock(_component_CompanyTile, {
                key: 0,
                class: "header",
                name: $data.company.name,
                logo: $data.company.logo_url,
                type: $data.type
              }, null, 8 /* PROPS */, ["name", "logo", "type"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_ScrollBar, {
            class: "settings",
            disabled: $options.saving,
            "bar-x-offset": "-2rem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TrackerSegment, {
                title: "Relationship",
                tooltip: "relationship"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerButtongroup, {
                    modelValue: $data.company.tracker_type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.company.tracker_type) = $event)),
                    options: $data.TYPES,
                    class: "button-group"
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "TRACKER SENSITIVITY",
                tooltip: "signal_sensitivity"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerSlider, {
                    modelValue: $options.slider_focus,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.slider_focus) = $event)),
                    class: "slider",
                    step: 50,
                    "show-tooltip": false,
                    greyed: $options.focus_text
                  }, null, 8 /* PROPS */, ["modelValue", "greyed"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "EMAIL ALERTS",
                tooltip: "email_notifications"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerButtongroup, {
                    modelValue: $data.company.tracker_alerts,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.company.tracker_alerts) = $event)),
                    options: $data.ALERTS,
                    class: "button-group"
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "WHAT SHOULD WE WATCH FOR?",
                tooltip: "company_customize_tracking"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerTextarea, {
                    modelValue: $data.company.focus_on,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.company.focus_on) = $event)),
                    title: "Focus tracking on:",
                    placeholder: "e.g. product launches, partnerships, executive changes",
                    class: "textarea"
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_SectionTitle, {
                      title: "PEOPLE WE'RE TRACKING AT THIS COMPANY",
                      tooltip: "people_tracking"
                    }),
                    _createVNode(_component_PulseButton, {
                      text: "Track person",
                      color: "var(--text-secondary-700)",
                      icon: "plus",
                      small: "",
                      class: "add-button",
                      onClick: _cache[4] || (_cache[4] = $event => ($options.trackPerson()))
                    })
                  ]),
                  (!!$options.contacts?.length)
                    ? (_openBlock(), _createBlock(_component_TrackerContacts, {
                        key: 0,
                        contacts: $options.contacts,
                        onEditPerson: _cache[5] || (_cache[5] = $event => ($options.editPerson($event)))
                      }, null, 8 /* PROPS */, ["contacts"]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_3, _cache[6] || (_cache[6] = [
                        _createTextVNode(" You are not tracking any people at this company."),
                        _createElementVNode("br", null, null, -1 /* HOISTED */),
                        _createTextVNode("Start tracking to see them here. ")
                      ])))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"]),
          _createVNode(_component_Divider, { m: "0 -2.4rem 2.4rem" }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              class: "delete-button",
              disabled: $options.saving,
              onClick: $options.openDeleteModal
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: "trash-2",
                  size: "1.5rem",
                  stroke: "var(--error-500)"
                }),
                _cache[7] || (_cache[7] = _createTextVNode(" Delete Tracker "))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "onClick"]),
            _createVNode(_component_Button, {
              primary: "",
              disabled: !$options.can_save,
              loading: $options.saving,
              onClick: $options.onSave
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode(" Save ")
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
          ]),
          _createVNode(_component_TrackerDelete, { ref: "delete" }, null, 512 /* NEED_PATCH */)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}